{
  "general": {
    "tools": "Tools"
  },
  "header": {
    "nav.docs": "Documentation",
    "nav.specification": "Specification"
  },
  "toolsWalletAddress": {
    "heading.message": "Wallet address",
    "tooltip.ariaLabel": "Why connect your wallet?",
    "tooltip.message": "Connecting your wallet allows us to save your custom profiles, link them to you as the original author, and verify ownership for future updates.",
    "tooltip.message2": "It also enables Web Monetization on your behalf by embedding your wallet address into your web page automatically.",
    "errors.fieldRequired": "This field is required",
    "errors.connectionError": "You have not connected your wallet address yet.",
    "status.connect": "If you're connecting your wallet address for the first time, you'll start with the default profile. You can then customize and save your profile as needed.",
    "status.noSavedProfiles": "There are no custom edits for the {{toolName}} correlated to this wallet address but you can start customizing when you want.",
    "status.profilesFetched": "We've loaded your profiles. Feel free to keep customizing your {{toolName}} to fit your style.",
    "button.loadingLabel": "Connecting...",
    "button.submitLabel": "Continue",
    "button.disconnectAriaLabel": "Disconnect wallet"
  },
  "paywall": {
    "inputgroup.price.title": "Price",
    "inputgroup.price.titleDesc": "What visitors pay to unlock",
    "inputgroup.price.desc": "Set the one-time payment amount visitors pay to unlock this page’s gated content.",
    "input.price.label": "Amount",
    "input.price.hint": "Charged in your wallet's currency ({{currency}})",
    "inputgroup.placement.title": "Paywall placement",
    "inputgroup.placement.titleDesc": "When and how the gate appears",
    "inputgroup.placement.desc": "Choose how much of the page the paywall covers, and when it appears to the visitor.",
    "input.coverage.label": "Coverage on the page",
    "input.coverage.hint": "How much of the screen the paywall takes when it appears.",
    "input.delay.label": "Show paywall after",
    "input.delay.hint": "Set to 0 to show the paywall immediately on page load."
  }
}
